import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useTiptapStore = defineStore('tiptap', () => {
    const editor = ref(null)
    const isFocused = ref(false)
    const selectionUpdated = ref(0)
    const isEnableRegenerateText = ref(false)
    const selectedText = ref('')

    const setFocused = mode => isFocused.value = mode
    const setSelectionUpdated = times => selectionUpdated.value = times

    const isVisibleEditLnk = ref(false)
    const showVisibleEditLnk = () => isVisibleEditLnk.value = true
    const hideVisibleEditLnk = () => isVisibleEditLnk.value = false

    const getHighlightedText = () => {
        const { state} = editor.value;
        const {from, to} = state.selection;
        let text = '';

        state.doc.nodesBetween(from, to, (node, pos, parent) => {
            if (node.isText) {
                const start = Math.max(from, pos);
                const end = Math.min(to, pos + node.nodeSize);
                text += node.text.slice(start - pos, end - pos);
            }
        });
        selectedText.value = text;
    };
    
    const setSelectedText = (selectedText) => {
        selectedText.value = selectedText
    };
    
     const isParagraph = (text) => {
        // Check for length (more than one sentence)
        const sentences = text.split('.');
        if (sentences.length < 2) {
            return false;
        }
        
        if (text.length < 50) {   
            return false;
        }
        
        return true;
    }

    const setEditor = val => {
        editor.value = val;

        // Add the selectionUpdate listener here
        editor.value.on('selectionUpdate', () => {
           getHighlightedText();
           isEnableRegenerateText.value = false
           
           if(isParagraph(selectedText.value) && selectedText.value !== '') {
             isEnableRegenerateText.value = true;
           }
        });
    }
    
    return { 
        editor,
        selectionUpdated,
        isFocused,
        isVisibleEditLnk,

        setSelectionUpdated,
        setFocused,
        setEditor,
        showVisibleEditLnk, 
        hideVisibleEditLnk,
        getHighlightedText,
        isEnableRegenerateText,
        selectedText,
        setSelectedText
    }
})
